import { Heading, Text, VStack } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { Button } from "../components/chackra-ui-button";

type Props = {
  titleKey: string;
  bodyKey?: string;
  actionKey?: string;
  onAction?: () => void;
};

export const KioskTerminalView = ({
  titleKey,
  bodyKey,
  actionKey,
  onAction,
}: Props) => {
  const { t } = useTranslation();
  return (
    <VStack minH="100vh" justify="center" spacing={4} px={6} textAlign="center">
      <Heading size="lg">{t(titleKey)}</Heading>
      {bodyKey ? <Text color="slate.600">{t(bodyKey)}</Text> : null}
      {actionKey && onAction ? (
        <Button variant="senseiFilled" onClick={onAction}>
          {t(actionKey)}
        </Button>
      ) : null}
    </VStack>
  );
};
